import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CompanyDashboard from '../pages/company/CompanyDashboard';
import CompanyProfilePage from '../pages/company/CompanyProfilePage';
import MappedFarmerPage from '../pages/company/MappedFarmerPage';
import FarmerDetailsPage from '../pages/company/FarmerDetailsPage';
import { useAuth } from '../context/AuthContext';

// This will be a protected route component for company routes
const CompanyRoutes = () => {
  const { isAuthenticated, role } = useAuth();

  // If not authenticated or not a company, redirect to login
  if (!isAuthenticated || role !== 'company') {
    return <Navigate to="/login" />;
  }

  return (
    <Routes>
      <Route path="/" element={<CompanyDashboard />} />
      <Route path="profile" element={<CompanyProfilePage />} />
      <Route path="mapped-farmers" element={<MappedFarmerPage />} />
      <Route path="farmer/:id" element={<FarmerDetailsPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default CompanyRoutes;
